module.exports = __webpack_public_path__ + "static/img/3.e6038fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel-1/3.jpg
// module id = R7d/
// module chunks = 1